export default __webpack_public_path__ + "static/media/checkbox-marked-circle.caa8e910.svg";